export const displayTbOrGb = (storage, t) => {
    const translate = t || ((key) => key === "tib" ? "TiB" : key === "gib" ? "GiB" : key);
    return storage >= 1024
      ? `${Number((storage / 1024).toFixed(1))} ${translate("tib")}`
      : `${Number(storage)} ${translate("gib")}`;
  };